import React from 'react'
import { ProductCard } from "./ProductCard"
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import Heading from './Heading'

const ProductListing = ({blok}) => {

    const { products } = blok

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white pt-16 pb-20 px-6 lg:pt-24 lg:pb-28 lg:px-8">
                <div className="relative mx-auto max-w-7xl">
                    <Heading size="h1" className="text-darkgrey text-6xl">{blok.title}</Heading>
                    <div className="prose text-darkgrey text-sm max-w-3xl">
                        <RichText>{blok.description}</RichText>
                    </div>
                    <div className="bg-white grid sm:grid-cols-3 grid-cols-1 gap-8 lg:pt-20 pt-10">
                        {products.map((p, index) => {
                            const { product: { item }} = p
                            return(
                                item && <ProductCard product={item} key={item?.id} eager={index === 0} />
                            )
                        })}
                    </div>
                </div>
            </div>
        </SbEditable>
    )    
}

export default ProductListing